import axios from 'axios';
import  { useEffect, useState } from 'react'
import { BASE_URL } from '../constants/urls';

const useCashbackData = ({userId}) => {


    const [cashbackStatus, setCashbackStatus] = useState([]);
    const [cashbacks, setCashbacks] = useState([]);
    const [loadingCashback, setLoading] = useState(true);
    const [errorCashback, setError] = useState(null);

    useEffect(() => {

        const fetchCashbackData = async () => {
            try {
                    const cashbackStatusResponse = await axios.get(`${BASE_URL}/cashback/count`, {
                        params: { userId },
                        headers: {
                            Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                        },
                    });
                    setCashbackStatus(cashbackStatusResponse.data);
    
                    const cashbackResponse = await axios.get(`${BASE_URL}/cashback`, {
                        params: { userId },
                        headers: {
                            Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                        },
                        
                    });
                    setCashbacks(cashbackResponse.data);
                
            } catch (err) {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                setError(msg);
            } finally {
                setLoading(false)
            }
        };

    fetchCashbackData();

    }, []);

    return { cashbackStatus, cashbacks, loadingCashback , errorCashback}
}

export default useCashbackData